import React, { useState, useEffect } from "react";
import { createModalConfig, ModalConfig } from "../../../Models/ModalConfig";
import { Shipment } from "../../../Models/Shipment";
import { ShipmentsService } from "../../../services/shipment/shipments";
import { callErrorToast } from "../../../utilities/utilities";
import { useParams } from "react-router-dom";
import {
  ShipmentDetailsContextValue,
  ShipmentDetailsProviderProps,
} from "./types";
import { ShipmentDetailsContext } from "./contexts";
import { useQuery } from "../../../utilities";
import { useAppContext } from "../../../AppProvider";

const shipmentsService = new ShipmentsService();

export const ShipmentDetailsProvider: React.FC<
  ShipmentDetailsProviderProps
> = ({ children }) => {
  const { dictionary } = useAppContext();
  const [data, setData] = useState<Partial<Shipment>>({});
  const [loader, setLoader] = useState<boolean>(true);

  const [modalConfig, setModalConfig] =
    useState<ModalConfig>(createModalConfig());

  //acr = ask collection reservetion
  const [acr, setAcr] = useState<boolean>(false);

  const { id } = useParams();
  const query = useQuery();

  const getShipmentDetails = async (id: string) => {
    setLoader(true);
    try {
      const res = await shipmentsService.get(id);
      setData(res.data);
      if (
        res.data.contractService?.carrierService?.carrier
          .collectionCreationEnabled &&
        !res.data.collectionAssigned &&
        acr &&
        (res.data.status.code === "BOOKED" ||
          res.data.status.code === "CONFIRMED")
      ) {
        setModalConfig({
          isOpen: true,
          size: "md",
          action: "createCollection",
          data: [id],
          title: dictionary.collections.do_you_want_to_book_a_collection,
        });
      }
      return res;
    } catch (err) {
      callErrorToast(err);
      throw err;
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    if (id) {
      getShipmentDetails(id);
      return;
    }
    setLoader(false);
  }, [id]);

  useEffect(() => {
    const acr = query.get("acr");
    setAcr(acr === "true");
  }, []);

  const contextValue: ShipmentDetailsContextValue = {
    modalConfig,
    setModalConfig,
    data,
    loader,
    getShipmentDetails,
    acr,
    setAcr,
  };

  return (
    <ShipmentDetailsContext.Provider value={contextValue}>
      {children}
    </ShipmentDetailsContext.Provider>
  );
};
